import { createContext, useContext, useState, useEffect } from "react";
import { setTheme } from "../styles/token.js";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem("srt-theme") || "light";
  });
  

  useEffect(() => {
    setTheme(mode);
    localStorage.setItem("srt-theme", mode);
    console.log("theme", mode);
    document.body.style.background = mode === "dark" ? "#0d0f17" : "#f7f7f6";
  }, [mode]);

  const toggle = () => setMode(m => m === "light" ? "dark" : "light");

  return (
    <ThemeContext.Provider value={{ mode, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);